export enum eEngageAdvPeriod {
    ThisMonth = 0,
    LastMonth = 1
}

export enum eEngageAdvGroupBy {
    Channel = 0,
    Site = 1
}

export enum eEngageAdvRowLevel {
    Month = 0,
    Group = 1,
    GrandTotal = 2
}

export interface EngageAdvFilter {
    period: eEngageAdvPeriod;
    useCustomRange: boolean;
    fromDate: string;
    toDate: string;
    teamCodes: number[];
    channels: string[];
    year: number;
    groupBy: eEngageAdvGroupBy;
}

export interface EngageAdvWindow {
    name: string;
    start: string;
    end: string;
    isCustomRange: boolean;
    label: string;
}

export interface EngageAdvResponseBase {
    statusCode: number;
    errorMsg: string;

    note: string;
}

export interface EngageAdvSummary {
    window: EngageAdvWindow;
    totalLeads: number;
    slidecastsViewed: number;
    contracts: number;
    adSpend: number;

    adSpendApplicable: boolean;

    slidecastsApplicable: boolean;
    ltv: number;

    priorWindow: EngageAdvWindow | null;
    priorTotalLeads: number | null;
    priorSlidecastsViewed: number | null;
    priorContracts: number | null;
    priorAdSpend: number | null;
    priorLtv: number | null;
}

export interface EngageAdvSummaryResponse extends EngageAdvResponseBase {
    summary: EngageAdvSummary;
}

export interface EngageAdvPoint {
    label: string;
    date: string;
    value: number;
}

export interface EngageAdvSeries {
    name: string;
    points: EngageAdvPoint[];
}

export interface EngageAdvDailyLeadsResponse extends EngageAdvResponseBase {
    series: EngageAdvSeries[];
    window: EngageAdvWindow;
}

export interface EngageAdvChannelRow {
    channel: string;
    leads: number;
}

export interface EngageAdvChannelsResponse extends EngageAdvResponseBase {
    rows: EngageAdvChannelRow[];
    total: number;
    window: EngageAdvWindow;
}

export interface EngageAdvLeadGenRow {
    level: eEngageAdvRowLevel;
    month: string;
    monthNumber: number;
    groupValue: string;

    totalLeads: number;

    contracts: number | null;
    initiationFee: number | null;
    membershipFee: number | null;
    ltv: number | null;
    avgLtv: number | null;
    m2L: string;

    impressions: number | null;
    clicks: number | null;
    ctr: number | null;
    conversions: number | null;
    cvr: number | null;
    adSpent: number | null;
    cpc: number | null;
    totalSpent: number | null;
    roas: number | null;
    cpl: number | null;
    cpm: number | null;
    monthlyResidual: number | null;
}

export interface EngageAdvLeadGenResponse extends EngageAdvResponseBase {
    rows: EngageAdvLeadGenRow[];

    unavailableColumns: string[];
    year: number;
    groupBy: eEngageAdvGroupBy;
}

export interface EngageAdvDropDownItem {
    id: string;
    text: string;
}

export interface EngageAdvDefaults {
    useCustomRange: boolean;
    period: eEngageAdvPeriod;
    fromDate: string;
    toDate: string;
    teamCode: number;
}

export interface EngageAdvFilterOptionsResponse extends EngageAdvResponseBase {
    teams: EngageAdvDropDownItem[];
    channels: EngageAdvDropDownItem[];
    years: EngageAdvDropDownItem[];
    defaults: EngageAdvDefaults;
}
